import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, combineLatest } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { AuthFacade } from '../../../auth';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../list-search-criteria';
import { MasterDataListSearchCriteria } from '../models';
import { MasterDataListInitialState, MasterDataListLoad } from './master-data-list.actions';
import { MasterDataListState, MasterDataListStateModel } from './master-data-list.state';

@Injectable({ providedIn: 'root' })
export class MasterDataListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<MasterDataListStateModel> = this.store.select(MasterDataListState.getState);
  loaded$: Observable<boolean> = this.store.select(MasterDataListState.getLoaded);

  constructor(
    private store: Store,
    private listSearchCriteriaFacade: ListSearchCriteriaFacade,
    public authFacade: AuthFacade,
  ) {}

  loadAll(): void {
    combineLatest([
      this.authFacade.timezone$,
      this.listSearchCriteriaFacade.getSearchCriteriaByListType(ListSearchCriteriaType.MasterDataReport),
    ]).subscribe(([timezone, filter]: [string, MasterDataListSearchCriteria]) => {
      this.store.dispatch(new MasterDataListLoad({ timezone, filter }));
    });
  }

  setInitialState(): void {
    this.store.dispatch(new MasterDataListInitialState());
  }
}
